<template>
  <span class="tag">
    <slot></slot>
  </span>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
  .tag{
    display: inline-block;
    font-size: 20px;
    padding: 2px 6px;
    background: #C4FFF3;
    border-radius: 8px;
    margin-bottom: 14px;
    margin-right: 5px;
    color: #16B998;
  }
</style>



// WEBPACK FOOTER //
// src/components/tag.vue